import React from "react";
import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";

export default function NotFound() {
  React.useEffect(() => { document.title = "Not Found - Pune Spa Guide"; }, []);
  return (
    <div data-testid="not-found-page" className="max-w-xl mx-auto px-4 py-24 text-center">
      <div className="font-heading text-7xl text-[#1F4E3D]">404</div>
      <h1 className="font-heading text-3xl mt-3">Page not found</h1>
      <p className="text-sm text-[#4B5563] mt-2">The page you&apos;re looking for doesn&apos;t exist or has moved.</p>
      <Link to="/"><Button className="mt-6 bg-[#111827] hover:bg-[#0B1220] text-white">Back to Home</Button></Link>
    </div>
  );
}
